import type { ChakraStylesConfig, GroupBase } from 'chakra-react-select';

type EntitySearchSelectStyleOptions = {
  /**
   * LandingSearch has a left-side entity dropdown button (a "left addon"),
   * so the select control has its left border-radius removed to visually connect.
   *
   * Most other usages should keep the default radius.
   */
  hasLeftAddon?: boolean;
};

export const createEntitySearchSelectChakraStyles = <TOption>({
  hasLeftAddon = false,
}: EntitySearchSelectStyleOptions = {}): ChakraStylesConfig<
  TOption,
  true,
  GroupBase<TOption>
> => ({
  container: (provided) => ({
    ...provided,
    w: '100%',
    color: 'text.primary',
  }),
  control: (provided) => ({
    ...provided,
    ...(hasLeftAddon
      ? {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }
      : {}),
    h: '100%',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: 'var(--es-chip-bg, rgb(236, 249, 254))',
    border: '1px solid var(--es-chip-border, rgb(162, 223, 249))',
    borderRadius: '4px',
    color: 'var(--es-chip-text, var(--chakra-colors-text-primary))',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'var(--es-chip-text, var(--chakra-colors-text-primary))',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: 'var(--es-chip-text, var(--chakra-colors-text-primary))',
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    textAlign: 'left',
    pl: 4,
    fontSize: 'md',
  }),
  menuList: (provided) => ({
    ...provided,
    maxH: '200px',
  }),
});
